import React from "react";
import { FEATURES } from "../constants";
import {
  FeaturesSection,
  FeaturesInner,
  FeaturesHeader,
  FeaturesTitle,
  FeaturesLead,
  FeatureGrid,
  FeatureCard,
  FeatureIconWrap,
  FeatureTitle,
  FeatureText,
} from "./Features.styles";

const Features = () => (
  <FeaturesSection id="features">
    <FeaturesInner>
      <FeaturesHeader>
        <FeaturesTitle>
          Everything You Need to <span>Stay Ahead</span>
        </FeaturesTitle>
        <FeaturesLead>
          Comprehensive coverage and tools designed for Bitcoin and Crypto
          investors
        </FeaturesLead>
      </FeaturesHeader>

      <FeatureGrid>
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.title}>
            <FeatureIconWrap aria-hidden="true">
              <span className="material-icons">{feature.icon}</span>
            </FeatureIconWrap>
            <FeatureTitle>{feature.title}</FeatureTitle>
            <FeatureText>{feature.description}</FeatureText>
          </FeatureCard>
        ))}
      </FeatureGrid>
    </FeaturesInner>
  </FeaturesSection>
);

export default Features;
